import googleRecaptchaController from './google-recaptcha.controller';
import googleRecaptchaView from './google-recaptcha.view.html';

const googleRecaptchaComponent = {
  template: googleRecaptchaView,
  bindings: {
    recaptchaId: '<',
    recaptchaSize: '<'
  },
  controller: googleRecaptchaController,
  controllerAs: 'vm'
};

export default googleRecaptchaComponent;


// WEBPACK FOOTER //
// ./src/components/googlerecaptcha/google-recaptcha.component.js